import { defineMessages } from 'react-intl';

export const siteMessages = defineMessages({
    editSite: {
        id: 'edit-site',
        defaultMessage: 'Edit site',
    },
    addSite: {
        id: 'add-site',
        defaultMessage: 'Add site',
    },
    addSiteSubtitle: {
        id: 'add-site-subtitle',
        defaultMessage: 'Add new site',
    },
    editSiteSubtitle: {
        id: 'edit-site-subtitle',
        defaultMessage: 'Edit site {entry}',
    },
    deleteSiteSubtitle: {
        id: 'delete-site-subtitle',
        defaultMessage: 'Permanently delete site {entry}',
    },
    confirmDeleteSite: {
        id: 'confirm-delete-site',
        defaultMessage: 'Are you sure you want to delete site {entry}? This action cannot be undone.',
    },
    sites: {
        id: 'sites',
        defaultMessage: 'Sites',
    },
    site: {
        id: 'site',
        defaultMessage: 'Site',
    },
    address: {
        id: 'address',
        defaultMessage: 'Address',
    },
    legalRepresentative: {
        id: 'legal-representative',
        defaultMessage: 'Legal representative',
    },
    createSiteSuccess: {
        id: 'create-site-success',
        defaultMessage: 'Site created',
    },
    updateSiteSuccess: {
        id: 'update-site-success',
        defaultMessage: 'Site updated',
    },
    deleteSiteSuccess: {
        id: 'delete-site-success',
        defaultMessage: 'Site deleted',
    },
    createSiteSuccessDescription: {
        id: 'create-site-success-description',
        defaultMessage: 'Site {entry} has been successfully created.',
    },
    updateSiteSuccessDescription: {
        id: 'update-site-success-description',
        defaultMessage: 'Site {entry} has been successfully updated.',
    },
    deleteSiteSuccessDescription: {
        id: 'delete-site-success-description',
        defaultMessage: 'Site {entry} has been successfully deleted.',
    },
    type: {
        id: 'type',
        defaultMessage: 'Type',
    },
    floorsCount: {
        id: 'floors-count',
        defaultMessage: 'Floors count',
    },
    is247: {
        id: 'is-24-7',
        defaultMessage: 'Is 24/7',
    },
    totalSpaces: {
        id: 'total-spaces',
        defaultMessage: 'Total spaces',
    },
    country: {
        id: 'country',
        defaultMessage: 'Country',
    },
    bulgaria: {
        id: 'bulgaria',
        defaultMessage: 'Bulgaria',
    },
    public: {
        id: 'public',
        defaultMessage: 'Public',
    },
    private: {
        id: 'private',
        defaultMessage: 'Private',
    },
    commercial: {
        id: 'commercial',
        defaultMessage: 'Commercial',
    },
    residential: {
        id: 'residential',
        defaultMessage: 'Residential',
    },
    city: {
        id: 'city',
        defaultMessage: 'City',
    },
    coordinates: {
        id: 'coordinates',
        defaultMessage: 'Coordinates',
    },
    longitude: {
        id: 'longitude',
        defaultMessage: 'Longitude',
    },
    latitude: {
        id: 'latitude',
        defaultMessage: 'Latitude',
    },
    organisation: {
        id: 'organisation',
        defaultMessage: 'Organisation',
    },
    siteDashboard: {
        id: 'site-dashboard',
        defaultMessage: 'Dashboard',
    },
    pricingPlans: {
        id: 'pricing-plans',
        defaultMessage: 'Pricing plans',
    },
    backToAllSites: {
        id: 'back-to-all-sites',
        defaultMessage: 'Back to all sites',
    },
    pluralSites: {
        id: 'plural-sites',
        defaultMessage: 'Sites',
    },
});